export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14282.31fa4767.jpg";